import React from 'react';
import styled from 'styled-components';
import { ConfigProvider, Table } from 'antd';
import { useCookies } from 'react-cookie';
import { theme } from 'utils/style/theme';
import { TableComponents } from 'rc-table/lib/interface';
/**
 * * 메인 테이블
 **/

interface IProps {
  columns?: object[];
  dataSource?: object[] | undefined;
  pagination?: string[] | any;
  imgWidth?: string;
  imgHeight?: string;
  expandedRowKeys?: Array<string> | Array<number>;
  onExpand?: (e: any, record: any) => void;
  expandedRowRender?: (e: any) => JSX.Element; // 리액트의 함수 컴포넌트
  expandRowByClick?: boolean;
  expandIconAsCell?: boolean;
  expandIconColumnIndex?: number;
  rowKey?: string | number | undefined | any;
  rowClassName?: any;
  components?: TableComponents<any> | JSX.Element;
  onChange?: () => void;
  backgroundColor?: string;
  bordered?: boolean;
  scroll?: any;
  // expandable?: IExpandableTable;
  expandable?: any;
  columnWidth?: string | number;
  server?: 'test' | 'server';
  props?: any;
  hideSortIcon?: boolean;
  isPagination?: boolean;
  isExpand?: boolean;
}
const MainTable = ({
  columns,
  dataSource,
  onExpand,
  expandable,
  expandedRowRender,
  expandRowByClick,
  expandedRowKeys,
  expandIconAsCell,
  rowKey,
  rowClassName,
  components,
  onChange,
  backgroundColor,
  bordered,
  scroll = { x: 'max-content' },
  hideSortIcon = false,
  isPagination = false,
  isExpand,
  ...props
}: IProps) => {
  const [cookies] = useCookies();

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            colorBgTextHover: 'red',
          },
        },
      }}
    >
      <TableStyle
        expandable={expandable}
        server={cookies?.server}
        columns={columns}
        dataSource={dataSource}
        pagination={
          isPagination
            ? dataSource && dataSource?.length < 7
              ? false
              : {
                  position: ['bottomCenter'],
                  showSizeChanger: false,
                  defaultCurrent: 1,
                  pageSize: 7,
                  total: dataSource?.length,
                }
            : false
        }
        expandedRowKeys={expandedRowKeys}
        onExpand={onExpand}
        expandedRowRender={expandedRowRender}
        expandRowByClick={expandRowByClick}
        expandIconAsCell={expandIconAsCell}
        rowKey={rowKey}
        rowClassName={rowClassName}
        components={components}
        backgroundColor={backgroundColor}
        onChange={onChange}
        bordered={bordered}
        expandIconColumnIndex={0}
        // scroll={scroll === undefined ? { y: '50rem' } : scroll}
        scroll={scroll}
        columnWidth='1rem'
        hideSortIcon={hideSortIcon}
        isExpand={isExpand}
        {...props}
      />
    </ConfigProvider>
  );
};
export default MainTable;
const TableStyle = styled(Table)<IProps>`
  .ant-table {
    /* background: transparent; */
    /* box-shadow: 0 0 4px 0 rgb(0 0 0 / 5%); */
    padding-bottom: 24px;
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 0.5rem;
  }
  .ant-table-container table thead tr th:first-child {
    width: 79px;
    text-align: center;
  }
  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 0.5rem;
  }
  .ant-table-container thead tr th {
    border-bottom: 1px solid #e9eaeb !important;
  }
  // 테이블 헤더
  .ant-table-thead > tr > th,
  .ant-table-thead > tr > td {
    background-color: transparent;
    color: ${(props) =>
      props?.server === 'server' ? '#fff' : theme.colors.blueText};
    font-weight: 600;
    font-size: 0.85rem;
    /* 텍스트 사이에 \n을 넣어 개행이 가능하게 한다. */
    white-space: pre-line;
  }

  .ant-table-thead > tr > th {
    color: ${theme.colors.dark_400};
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.bold};
    line-height: 24px;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    p,
    span {
      color: ${theme.colors.dark_400};
      font-size: ${theme.fontSizes.normal};
      font-style: normal;
      font-weight: ${theme.fontWeights.bold};
      line-height: 24px;
      letter-spacing: 0.1px;
      text-transform: uppercase;
    }
  }

  .ant-table-tbody > tr > td {
    padding: 0.8rem 0.8rem;
    background-color: transparent;
    border-bottom: 1px solid #e9eaeb !important;
    color: ${theme.colors.dark_400};
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.medium};
    line-height: 20px;
    letter-spacing: 0.2px;
    p,
    span {
      color: ${theme.colors.dark_400};
      font-size: ${theme.fontSizes.sm};
      font-style: normal;
      font-weight: ${theme.fontWeights.medium};
      line-height: 20px;
      letter-spacing: 0.2px;
    }
  }

  .ant-image {
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  /* 테이블 내에 삽입된 이미지 설정 */
  .ant-image-img {
    object-fit: contain;
    height: 5rem;
  }

  /* 테이블 내 동작 열에 있는 버튼 모음 */
  .button_in_table {
    > button {
      margin-right: 0.5rem;
    }
  }

  /* ! ↓↓ 확인해야 해 23.1.18 */

  /* expandable table 아이콘 열 */
  th.ant-table-cell.ant-table-row-expand-icon-cell,
  td.ant-table-cell.ant-table-row-expand-icon-cell {
    padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  }
  tr.ant-table-expanded-row > td,
  tr.ant-table-expanded-row:hover > td {
    background: ${theme.colors.gray_1};
  }
  .ant-checkbox-disabled .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: ${theme.colors.blueText};
  }
  /* main table상에서 input입력해야할경우 */
  .ant-input-affix-wrapper,
  .ant-input-borderless {
    border: solid 1px ${theme.colors.gray_4};
  }
  /* 테이블 내 sort 아이콘 */
  .ant-table-column-sorter-inner {
    color: ${theme.colors.gray_3};
  }
  && tbody > tr:hover {
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
  }
  && tbody > tr:hover > td {
    background-color: transparent !important;
  }

  .ant-table-row > td:last-child {
    border-start-end-radius: 8px;
    border-end-end-radius: 8px;
  }
  .ant-table-row > td:first-child {
    border-top-left-radius: 8px;
    border-start-start-radius: 8px;
    border-bottom-left-radius: 8px;
    border-end-start-radius: 8px;
  }
  .ant-table-thead .ant-table-cell::before {
    content: none !important;
  }
  /* hide sort icon */
  .ant-table-column-sorter {
    display: ${(props) => (props.hideSortIcon ? 'none' : 'block')};
  }

  .active {
    background-color: #eaeffb;
  }

  .ant-table-content td,
  .ant-table-content th {
    vertical-align: middle;
  }
`;
